import React from "react";
import { Link } from "react-router-dom";
import "../../assets/css/searchgrid.css";
import Skeleton from 'react-loading-skeleton';
import "react-loading-skeleton/dist/skeleton.css";

const Searchgrid = ({
  totalProducts,
  search,
  setSearch,
  item = {},
   slug,
   loading,
   source,
   includeComingSoon,


}) => {
  return (
    <section className="searchgrid-link">
      <div className="container">
       {loading ? (
            <Skeleton height={50}/>
      ):( 
        <div className="box00023">
          <div className="row">
            <div className="col-md-8 col-sm-6">
              
              <h4>Showing <b>{totalProducts}</b> items</h4>
            </div>

            <div className="col-md-4 col-sm-6">
               <div className="content-justify">
                <div className="justify-content-end align-items-center">
                  <div className="input-icon">
                    <i className="bi bi-search font-sm"></i>

                    <input
                      type="text"
                      placeholder="Design Shade..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      className="form-control form-control-sm bg-white input inputwidth"
                    />
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: "6px",
                    justifyContent: "flex-end",
                  }}
                 >
                  {/* <div className="buttonfilter mt-1">
                    <MobileFiltergrid />
                  </div> */}

                  <Link to={`/products/${slug}/list?source=${source}&includeComingSoon=${includeComingSoon}`} className="iconmargin icon-borders-grid">
                    <i className="bi bi-list-task"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      </div>
    </section>
  );
};

export default Searchgrid;